import Base from '../Base';

export default class UserData extends Base {
  constructor(item) {
    super(item.id, '/user-data');

    this.data = item.data;
  }
}
